class BESSAppDocumentLibrary extends BESSAppBase {

    constructor(parent) {
        super();
        this.parent = parent;
        this.node = $('.app-document-library');
        this.documents = this.#loadDocLibrary();
        this.node.showIf(this.documents.length > 0);
    }

    updateState(result) {
        let newNode = $(result['doc-library']);
        this.node.replaceWith(newNode);
        this.node = newNode;
        this.documents = this.#loadDocLibrary();
        this.node.showIf(this.documents.length > 0);
    }

    #loadDocLibrary() {
        let docs = [];
        this.forEach($('.app-document-library-item'), function (x) {
            let node = $(x);
            let docId = node.attr('data-doc-id');
            let docType = node.attr('data-doc-type');
            let docName = node.find('.app-doc-name-text').text();
            docs.push(new BESSAppProjectDoc(docId, docType, docName, node, this.parent));
        });
        return docs;
    }
}


class BESSAppProjectDoc extends BESSAppBase {
    static PROJECT_DOCUMENT_TYPE_WILL_BE_PRINTED = 0;
    static PROJECT_DOCUMENT_TYPE_UPLOADED = 1;

    docId;
    docType;
    docName;


    constructor(docId, docType, docName, node = null, parent = null) {
        super();
        this.docId = '' + docId;
        this.docType = docType;
        this.docName = docName;
        this.selectText = this.docName;
        if (this.docType === BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_WILL_BE_PRINTED) {
            this.selectText += ' (To be printed)';
        } else {
            this.selectText += ' (Uploaded)';
        }
        this.node = node;
        this.parent = parent;
        if (this.node != null) {
            this.node.find('.app-rename').bindClickEvent(this, this.#onRename);
            this.node.find('.app-remove').bindClickEvent(this, this.#onRemove);
        }

    }

    #onRename() {
        this.askForTextInput('Rename Project Document', null, this.docName, this.#onDoRename);
    }

    #onDoRename(renameText) {
        this.docName = renameText;
        this.selectText = this.docName;
        if (this.docType === BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_WILL_BE_PRINTED) {
            this.selectText += ' (To be printed)';
        } else {
            this.selectText += ' (Uploaded)';
        }
        this.parent.api().renameDocument(this.docId, renameText, this.#onRenamedDocument.bind(this));
    }

    #onRenamedDocument(result) {
        $('.app-doc-name[data-doc-id="' + this.docId + '"]').text(this.selectText);
        this.parent.updateState(result.state);
    }

    #onRemove() {
        this.askUserToConfirmSeriousOperation('Remove Project Document',
            'Remove this Project Document? This will remove it from any Supporting Documentation required for this project.',
            this.#doRemove.bind(this),
            'Yes - Remove Project Document'
        );
    }

    #doRemove() {
        this.parent.api().removeDocument(this.docId, this.#onRemoved.bind(this));
    }

    #onRemoved(result) {
        this.parent.updateState(result.state);
        this.parent.removedDocument(this.docId);
    }
}